<script lang="ts">
	import { clickOutside } from "./click_outside";
	import { fade } from "svelte/transition";
	export let visible: boolean = false;
</script>

{#if visible}
	<div
		in:fade
		out:fade
		class="popup"
		on:outclick={() => (visible = false)}
		use:clickOutside
	>
		<div class="exit" on:click={() => (visible = false)}>X</div>
		<slot />
	</div>
{/if}

<style>
	.popup {
		position: fixed;
		bottom: 10%;
		left: 10%;
		outline: 2px solid gray;
		background-color: var(--background-3);
		width: 80%;
		height: 80%;
		overflow: auto;
		z-index: 1;
	}
	.exit {
		background-color: var(--background-3);
		color: var(--text);
		float: right;
		padding: 10px;
		font-size: 1.5em;
		cursor: pointer;
	}
</style>
